exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nh2[data-v-40f9a9bd] {\n  font-weight: normal;\n  margin: 0px 0px 0px;\n}\n", ""]);

// exports
